export const getInitialState = isMockedData => {
  if (isMockedData) {
    const now = new Date();
    now.setYear(now.getFullYear() + 1);

    return {
      backgroundImage:
        'https://deum-static.s3-eu-central-1.amazonaws.com/accounts/1516868980247126016/uploads/images/6806ea31-f12b-9647-84b2-06b87cce2e0e.jpg',
      deathPrayersCookiesPolicy: '',
      deathPrayersFeatureFlag: true,
      deathPrayersPrivacy: '',
      deathPrayersRegulations: '',
      deathPrayersSuccessPaymentPageAdditionalText: '',
      deathPrayersTypes: ['single', 'yearly'],
      deathPrayersFormPhoneField: false,
      deathPrayersAmount: {
        predefinedValues: [50, 100, 150],
        allowOwnAmount: true,
        minimalValue: 30,
      },
      donationCookiesPolicy: '',
      donationFeatureFlag: true,
      donationPrivacy: '',
      donationRegulations: '',
      donationSuccessPaymentPageAdditionalText: 'Msza św. za darczyńców o 18.',
      inboxMassOfferingsActive: true,
      massOfferingAfterPaymentText:
        'Potwierdzenie płatności otrzymasz od operatora w wiadomości email.',
      massOfferingAmount: {
        predefinedValues: [30, 60, 100, 0],
        allowOwnAmount: true,
        minimalValue: 1,
      },
      massOfferingBeforeFormText:
        'Możemy kontaktować się z Tobą, jeśli intencja modlitwy nie będzie dla nas jasna.2',
      massOfferingCookiesPolicy: '',
      massOfferingFeatureFlag: true,
      massOfferingMassRequestMaxToDate: new Intl.DateTimeFormat('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(now),
      massOfferingMassRequestMinFromDate: new Intl.DateTimeFormat('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        // start from day after tomorrow
      }).format(new Date(new Date().setDate(new Date().getDate() + 2))),
      massOfferingPhoneNumberRequired: true,
      massOfferingPrivacy: '',
      massOfferingRegulations: '',
      massOfferingReservation: {
        standardReservation: {
          reservationTimeInDays: '1',
        },
        paymentToBeChosenReservation: {
          enabled: false,
          reservationTimeInDays: '7',
          availableMinimumXDaysBefore: 14,
        },
      },
      massOfferingSuccessPaymentPageAdditionalText: '',
      pastoralVisitPreferredTimeSlots: {
        label: 'Preferencje godzinowe',
        slots: ['11:00-13:00', '17:00-20:00'],
      },
      pastoralVisitPreferredTimeSlotsFeatureFlag: true,
      perpetualMassOfferingAmount: {
        predefinedValues: [30, 60, 100, 0],
        allowOwnAmount: true,
        minimalValue: 1,
      },
      pastoralVisitTextBeforeForm:
        '<p>w Parafii Rzymskokatolickiej</p><p>"Kolęda" odbywa się na zaproszenie wiernych</p><p>Zgłoszenia przyjmujemy do 6 \\ stycznia:</p>',
      pastoralVisitActivePeriod: { from: '2023-09-22', to: '2023-12-31' },
      pastoralVisitFeatureFlag: true,
      perpetualMassOfferingFormAddressField: true,
      perpetualMassOfferingBeforeText:
        '<p>W intencji wskazanej osoby bedziemy modlic sie podczas Mszy Swietych wieczystych odprawianych codziennie o 6:30 w Sanktuarium w Kodniu.<br />Wszyscy zgtoszeni do Mszy wieczystych maja w nich udziat równiez po smierci.</p>',
      perpetualMassOfferingFeatureFlag: true,
      associationMassOfferingFeatureFlag: true,
      associationMassOfferingAmount: {
        predefinedValues: [],
        allowOwnAmount: true,
        minimalValue: 1,
      },
      associationMassOfferingBeforeText: '',
      serviceFeeEnabled: true,
      serviceFeeCoveredDefault: true,
      serviceFeeCoveredRequired: false,
      tpayApiFeatureFlag: false,
      publicMassOffering: false,
    };
  }

  return {};
};
